/// <reference path="../../../../typings/index.d.ts" />
/// <reference path='customBranding.module.ts' />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/baseClasses/dataMaintenanceContextBase.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.CustomBranding {
    import StorageFile = Meevo.Model.IStorageFile;
    "use strict";

    export class CustomBrandingContext extends Meevo.Components.CommonClasses.CommonContextBase {

        constructor(appSettings: Meevo.Components.Common.IAppSettings,
                    protected dataService: Meevo.Components.CommonClasses.ICommonDataService,
                    modalService: Meevo.Components.Modal.IModalService,
                    identityService: Meevo.Components.Common.IIdentityService,
                    loggingService: Meevo.Components.Logging.ILoggingService,
                    securityChecker: Meevo.Components.Common.ISecurityService,
                    trackingService: Meevo.Components.Tracking.ITrackingService,
                    protected busyService: Meevo.Components.Busy.IBusyService,
                    protected $translate: angular.translate.ITranslateService,
                    protected $q: ng.IQService
        ) {

            super(appSettings, dataService, modalService, identityService, loggingService, securityChecker, trackingService);

            this.buildCrudSecurityKeysBase(this.securityKeys.MANAGEMENT_CUSTOMBRANDING_TAB_MAIN);
            // initialize endpoint
            this.baseEndpoint = appSettings.API_ENDPOINTS.customBranding;
            // initialize template paths
            this.sectionTemplatePath = "app/plugins/customBranding/sectionViews/";

            this.initializeSections();

            this.buildCrudSecurityKeysBase(this.securityKeys.MANAGEMENT_CUSTOMBRANDING_TAB_MAIN);
        }

        /**
         * Responsible for initializing all sections belonging to the maintenance service.
         * @return {}
         */
        initializeSections(): void {
            let baseSectionProps: Meevo.Model.ISectionParamsCommonDataService = {
                sectionId: 0,
                displayNameContentKey: '',
                template: '',
                isPrimarySection: false,
                handlesOwnCrud: false,
                baseEndpoint: this.baseEndpoint,
                sectionEndpoint: '',
                loggingService: this.loggingService,
                identityService: this.identityService,
                dataService: this.dataService,
                noun: Meevo.Model.NounEnum.CustomBranding,
                busyService: this.busyService,
                $q: this.$q
            };

            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.MANAGEMENT_CUSTOMBRANDING_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {

                this.sections.push(new CoverSection(_.extend({}, baseSectionProps, {
                    displayNameContentKey: 'SECTION_OB_COVER_DESIGN',
                    template: 'cover.html',
                    isPrimarySection: true,
                    modalService: this.modalService,
                    $translate: this.$translate,
                    sectionSecurityKey: this.securityKeys.MANAGEMENT_CUSTOMBRANDING_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ
                })));

                this.sections.push(new PageSection(_.extend({}, baseSectionProps, {
                    sectionId: 1,
                    displayNameContentKey: 'SECTION_OB_PAGE_DESIGN',
                    template: 'page.html',
                    modalService: this.modalService,
                    $translate: this.$translate,
                    sectionSecurityKey: this.securityKeys.MANAGEMENT_CUSTOMBRANDING_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ
                })));
            }

            this.activate();
        }

        /**
         * Responsible for initializing the header of the maintenance service.
         * This gets called only if isPrimarySection = true.  It supplies the model loaded
         * for the section to the method so that dynamic content can populate the header.
         * @return {}
         */
        initializeHeader(model: any): void {
          if (this.selectedSection.isPrimarySection) {
            this.headerContent = this.$translate.instant("SECTION_OB_COVER_DESIGN");
          } else {
            this.headerContent = this.$translate.instant("SECTION_OB_PAGE_DESIGN");
          }
          // Initialize business name value if arrives empty
          if (this.selectedSection.model && Model.Guard.isNothing(this.selectedSection.model.businessName))
            this.selectedSection.model.businessName = this.identityService.current().locationName;
        }

        /**
         * Selects the specified section of the maintance form and activates it.
         * @param {IDataMaintenanceSection} section
         * @returns {}
         */
        selectSection(section: Meevo.Components.CommonClasses.ICommonSection): void {
            // to reload custom branding data keep isLoaded false when you change section
            if (this.selectedSection) {
                this.selectedSection.isLoaded = false;
            }

            super.selectSection(section);

            this.initializeHeader({});
        }

        /**
         * Bind Image
         * @param {StorageFile} imageData
         * @param {any} url
         */
        public bindCustomBrandingImage(imageData: StorageFile, url: any): any {
            if (imageData) {
                url = this.searchFile(imageData, "Source", url);
            }
            return url;
        }

        public postCancel(): void {
          (<any>this.selectedSection).postCancel();
        }
    }
}
